module.exports = __webpack_public_path__ + "img/zx2.c5743ef0.png";